import BaseEntity from '../database/BaseEntity.js';

/**
 * AudioMP3 Entity
 * Represents a AudioMP3 in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class AudioMP3 extends BaseEntity {
  static collectionName = 'audiomp3s';
  static _schema = JSON.parse("{\"name\":\"AudioMP3\",\"type\":\"object\",\"properties\":{\"titulo\":{\"type\":\"string\",\"description\":\"Título de la canción o audio\"},\"artista\":{\"type\":\"string\",\"description\":\"Nombre del artista\"},\"album\":{\"type\":\"string\",\"description\":\"Nombre del álbum\"},\"url_audio\":{\"type\":\"string\",\"description\":\"URL del archivo de audio MP3\"},\"imagen_portada\":{\"type\":\"string\",\"description\":\"URL de la imagen de portada del audio\"},\"genero\":{\"type\":\"string\",\"enum\":[\"pop\",\"rock\",\"reggaeton\",\"salsa\",\"cumbia\",\"vallenato\",\"electronica\",\"clasica\",\"otro\"],\"default\":\"otro\",\"description\":\"Género musical\"},\"duracion\":{\"type\":\"string\",\"description\":\"Duración del audio (ej: 3:45)\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el audio está activo\"},\"orden\":{\"type\":\"number\",\"default\":0,\"description\":\"Orden de aparición\"}},\"required\":[\"titulo\",\"url_audio\"]}");
}

export { AudioMP3 };
export default AudioMP3;
